import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../../../components/DataTable/DataTable";
import { Link } from "react-router-dom";
import automService from "../../../../services/AutomService/AutomService";

// Import Pages
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import NewAccordion from "../../../../components/Accordion/NewAccordion";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";

// Import Icons
import emptyPageIcon from "../../../../assets/icons/configurationIcons/empty-page.svg";
import showLogsIcon from "../../../../assets/icons/configurationIcons/show-logs.svg";
import goAutom from "../../../../assets/icons/configurationIcons/go-autom-on-monitoring.svg";
import donloadLogIcon from "../../../../assets/icons/configurationIcons/advange-log-download.svg";
import quePoolIcon from "../../../../assets/icons/configurationIcons/que-pool-icon.svg";
import noneQuePoolIcon from "../../../../assets/icons/configurationIcons/none-queue-pool-icon.svg";
import RefreshIcon from '@material-ui/icons/Refresh';

// Import Material UI
import { CircularProgress, Tooltip } from "@material-ui/core";

import { alertState, atomSearchValue, personalizationState, schedulerNexRunTimes } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { convertToDateFormat } from '../../../../helpers/helper';


function ScheduleMonitor(props) {
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);
    const nextRunTimes = useRecoilValue(schedulerNexRunTimes);
    const [searchOperationValue, setSearchOperationValue] = useRecoilState(atomSearchValue);
    const [refresh, setRefresh] = useState({});
    const [customItemColumns, setCustomItemColumns] = useState([]);
    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
        setLoading,
        setData,
        searchQueueData,
        setSearchQueueData,
        showType,
        fetchQueueDetails,
        dataCount,
        outCurrentPage,
        handleSelectOperation
    } = props;
    const { t } = useTranslation();

    // useEffect(() => {
    //     getNextRunTimesOfSchedulers();
    // }, [showType]);

    // useEffect(() => {
    //     if (nextRunTimes) {
    //         setData(nextRunTimes);
    //         setSearchData(nextRunTimes);
    //     }
    // }, [nextRunTimes])

    // const getNextRunTimesOfSchedulers = async () => {
    //     // setLoading(true);
    //     const result = await automService.getNextRunTimesOfSchedulers(null, 0, null, searchOperationValue);
    //     if (result.status) {
    //         setData(result.data);
    //         setSearchData(result.data);
    //     } else {
    //         setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.MONITORING.' + result.message), severity: 'error' }))
    //     }
    //     // setLoading(false);
    // }

    const showColumn = () => {
        switch (showType) {
            case "singleView":
                return [
                    {
                        id: 1,
                        name: "id",
                        label: "",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <span className='index-number' >{searchData[dataIndex].index}.</span>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {
                                                <span
                                                    style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer", whiteSpace: "pre" }}
                                                    onClick={() => handleSelectOperation(searchData[dataIndex])}
                                                >
                                                    {searchData[dataIndex]?.autom_name}
                                                </span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "operation_status",
                        label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-schedule`}>
                                            {/* {searchData[dataIndex]?.operation_status} */}
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                <div className={`operation-status-dot-schedule`} style={{
                                                    borderRadius: "10px",
                                                    width: "6px", height: "6px",
                                                }}></div>
                                                Schedule
                                            </div>
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "mate",
                        label: t("MESSAGES.MONITORING.MATE-AGENT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-in-progress`}>
                                            {/* {searchData[dataIndex]?.operation_status} */}
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                <div className={`operation-status-dot-in-progress`} style={{
                                                    borderRadius: "10px",
                                                    width: "6px", height: "6px",
                                                }}></div>
                                                {searchData[dataIndex]?.mate_name}
                                            </div>
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 5,
                        name: "scheduled_at",
                        label: t("MESSAGES.MONITORING.SCHEDULED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return convertToDateFormat(searchData[dataIndex]?.scheduled_at, personalization.date_format, searchData[dataIndex]?.time_zone);
                                }
                            },
                        },
                    },
                    {
                        id: 6,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (searchData[dataIndex]) {
                                    let loadingLogs
                                    if (searchData[dataIndex].logs_status && searchData[dataIndex].logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container'>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                            <Tooltip title={t('MESSAGES.MONITORING.LOG-DETAIL')} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img alt="log-details" onClick={() => handleSelectOperation(searchData[dataIndex])} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${searchData[dataIndex]?.autom_id}/autom/edit`}
                                                >
                                                    <img className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                        </div >
                                    );
                                }
                            },
                        },
                    },
                ];
                break;
            default:
                return [
                    {
                        id: 1,
                        name: "image",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                return (
                                    <div className="queue-image-container">
                                        <img className="queue-image" src={dataIndex === 0 ? noneQuePoolIcon : quePoolIcon} />
                                    </div>
                                );
                            }
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.QUEUE-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {searchQueueData[dataIndex]?.pool_name ?
                                                <span>
                                                    {searchQueueData[dataIndex]?.pool_name}
                                                </span>
                                                : <span style={{ color: "#AEAEAE" }}>{t("MESSAGES.MONITORING.NONE-QUEUE")}</span>
                                            }
                                        </p >
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "status",
                        label: t("MESSAGES.MONITORING.TOTAL-OPERATIONS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <div className='queue-count-box count-schedule'>
                                        <p className='queue-count'>{searchQueueData[dataIndex].operation_count > 999 ? `+999` : searchQueueData[dataIndex].operation_count}</p>
                                    </div>;
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "created_at",
                        label: t("MESSAGES.MONITORING.CREATED-ON"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex] && searchQueueData[dataIndex]?.updated_at) {
                                    return convertToDateFormat(searchQueueData[dataIndex]?.updated_at, personalization.date_format);
                                }
                                return "-"
                            },
                        },
                    },
                    {
                        id: 5,
                        name: "refresh",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    // return <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                    return <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                }
                                return "-"
                            },
                        },
                    },
                ];
                break;
        }
    }

    const showChildColumn = () => {
        switch (showType) {
            case "longQueue":
                return [
                    {
                        id: 1,
                        name: "id",
                        label: "",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <span className='index-number' >{item.index}.</span>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {
                                                <span
                                                    style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer", whiteSpace: "pre" }}
                                                    onClick={() => handleSelectOperation(item)}
                                                >
                                                    {item?.autom_name}
                                                </span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "operation_status",
                        label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-schedule`}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                <div className={`operation-status-dot-schedule`} style={{
                                                    borderRadius: "10px",
                                                    width: "6px", height: "6px",
                                                }}></div>
                                                Schedule
                                            </div>
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "scheduled_at",
                        label: t("MESSAGES.MONITORING.SCHEDULED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return convertToDateFormat(item.scheduled_at, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 5,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (item) {
                                    let loadingLogs
                                    if (item.logs_status && item.logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container'>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                            <Tooltip title={t('MESSAGES.MONITORING.LOG-DETAIL')} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img onClick={() => handleSelectOperation(item)} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${item?.autom_id}/autom/edit`}
                                                >
                                                    <img className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                        </div >
                                    );
                                }
                            },
                        },
                    },
                ]
                break;
            case "automListView":
                return [
                    {
                        id: 1,
                        name: "info",
                        label: "",
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <div className={`operation-status-dot-schedule`} style={{
                                            borderRadius: "10px",
                                            width: "9px", height: "9px",
                                        }}></div>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.SCHEDULE"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px", maxWidth: "120px" }}>
                                            {
                                                <span
                                                    style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer" }}
                                                    onClick={() => handleSelectOperation(item)}
                                                >
                                                    {item?.autom_name}
                                                </span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (item) {
                                    let loadingLogs
                                    if (item.logs_status && item.logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container' style={{
                                            width: "fit-content", gap: "30px"
                                        }}>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 20px 0 0" }}></div>
                                            <Tooltip title={t('MESSAGES.MONITORING.LOG-DETAIL')} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img onClick={() => handleSelectOperation(item)} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${item?.autom_id}/autom/edit`}
                                                >
                                                    <img className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                        </div >
                                    );
                                }
                            },
                        },
                    },
                ]
                break;

            default:
                return
                break;
        }
    }

    useEffect(() => {
        let column = showColumn()
        const childColumn = showChildColumn()
        setCustomColumn(column);
        setCustomItemColumns(childColumn)
        setSearchKeyData(["autom_name"]);
    }, [searchData, showType, searchQueueData]);

    return (
        <div id="monitoring-table-container" className="table-container">
            {/* {loading ? <DataTableLoader /> : <> */}
            {loading ? <CircularProgress className="circular-progress-icon" size={40} /> : <>
                {!searchData.length && showType === "singleView" &&
                    <div className='empty-page-info-container'>
                        <img src={emptyPageIcon} />
                        <p className='info-text'>{t('MESSAGES.MONITORING.EMPTY-OPERATIONS')}</p>
                    </div>
                }
                {showType === "singleView" && searchData && searchData.length ? searchData.map((data, index) => {
                    return <NewAccordion
                        setSearchData={setSearchData} customColumns={customColumn}
                        data={data} index={index} setCustomColumn={setCustomColumn}
                        gridColumns={"0.4fr 1.5fr 1.5fr 1.5fr 1fr"} />
                }) : ""}
                {showType !== "singleView" && !searchQueueData?.length &&
                    <div className='empty-page-info-container'>
                        <img src={emptyPageIcon} />
                        <p className='info-text'>{t('MESSAGES.MONITORING.EMPTY-OPERATIONS')}</p>
                    </div>
                }
                {showType !== "singleView" && searchQueueData && searchQueueData.length ? searchQueueData.map((data, index) => {
                    return <NewAccordion
                        setSearchData={setSearchQueueData} customColumns={customColumn}
                        data={data} index={index} setCustomColumn={setCustomColumn}
                        showType={showType}
                        fetchChildItems={fetchQueueDetails}
                        gridColumns={"0.15fr 1fr 1fr 1fr"}
                        childGridColumns={"0.4fr 1.5fr 1.5fr 1.5fr 1fr"}
                        isAccordion={true} from={"schedule"} customItemColumns={customItemColumns}
                        refresh={refresh}
                    />
                }) : ""}</>}
        </div>
    );
}

export default ScheduleMonitor;
